// extracted by mini-css-extract-plugin
export default {"payNowBtnContainer":"AddTransaction_payNowBtnContainer__OyFG6"};